document.addEventListener("DOMContentLoaded", function () {
    // Check if the wrapping element exists and has the correct data-product-id
    const productContainer = document.querySelector(".mankai-product-container");
    
    if (productContainer && productContainer.getAttribute("data-product-id") === "7362364506179") {
        // Select all the label elements inside the swatches list
        const labels = document.querySelectorAll(".swatches .label-swatch");
        
        // Select all the information cards
        const infoCards = document.querySelectorAll(".multicolumn-card__info");

        // Loop through both NodeLists and replace text content
        labels.forEach((label, index) => {
            if (infoCards[index]) {
                label.innerHTML = infoCards[index].innerHTML; // Copy the content including HTML structure
            }
        });

        // Find the parent .shopify-section of the .multicolumn-card and hide it
        const shopifySection = document.querySelector(".multicolumn-card")?.closest(".shopify-section");
        if (shopifySection) {
            shopifySection.style.display = "none";
        }
    }
    
	/* Anchors scroller */
    const { innerWidth: width, innerHeight: height } = window;
    document.querySelectorAll('a[href^="#"]').forEach(link => {
        link.addEventListener('click', e => {
            const href = link.getAttribute('href');
            if (!href || href === '#') return; // ignore empty anchors

            const target = document.querySelector(href);
            if (!target) return;

            e.preventDefault();

            const topPadding = (window.innerWidth < 768) ? 100 : 70;
            const targetY = target.getBoundingClientRect().top + window.pageYOffset - topPadding;

            // Smooth scroll to the target position
            window.scrollTo({ top: targetY, behavior: 'smooth' });
        });
    });
});
